import To from 'await-to-js'
import qs from 'qs'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class QualityTaskService {
  // 查询列表
  static async getList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdDataQualityTask/GetList?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 查询详情
  static async detail(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdDataQualityTask/GetList?id=${payload.id}`)
    )
    return Callback(err, res)
  }
  // 获取字典
  static async getDic(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/DataCategory?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取cron表达式
  static async cron(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/DataItem?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增
  static async add(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdDataQualityTask/insert_task', payload)
    )
    return Callback(err, res)
  }
  // 更新
  static async update(payload) {
    const [err, res] = await To(
      wizStandardInstance.patch('/api/std/StdDataQualityTask/update_task', payload)
    )
    return Callback(err, res)
  }
  // 删除
  static async remove(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/StdDataQualityTask/delete_task', {
        data: payload,
      })
    )
    return Callback(err, res)
  }
  // 获取关联表数据-新增时
  static async getAssociationTableList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityTask/Get_Association_Table_List?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取关联表数据-查看编辑时
  static async getTaskAssociationTableList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityTask/Get_Task_Association_Table_List?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取实体列表
  static async getEntifyList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass/get_entity_list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 查询规则列表-旧
  static async getRuleList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdDataQualityRule?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 查询规则列表-新
  static async getRuleListNew(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdDataQualityRule/get_rule_list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 查询规则问题情况时间下拉框选项列表
  static async getProblemSelect(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityTaskRunRecord/GetList?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 查询规则问题情况列表
  static async getProblemList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityCheckResult/qs_get_rule_info_list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 导出规则问题情况列表
  static async exportRuleInfoList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityCheckResult/qs_get_rule_info_list_export?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 导出规则问题情况详情
  static async exportRuleDetail(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityCheckResult/qs_get_rule_info_details_export?${qs.stringify(
          payload
        )}`
      )
    )
    return Callback(err, res)
  }
  // 数据质量报告页面接口
  static async getReportData(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityCheckResult/get_data_quality_report?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }

  // 问题排行报告
  static async getDataQualityTopReport(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityCheckResult/get_data_quality_top_report?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 问题发现次数历史趋势报告
  static async getDataQualityHistoryReport(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityCheckResult/get_data_quality_history_report?${qs.stringify(
          payload
        )}`
      )
    )
    return Callback(err, res)
  }
  // 规则问题报告
  static async getDataRuleReport(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityCheckResult/get_data_rule_report?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 数据质量任务报告
  static async getDataQualityTaskReport(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityCheckResult/get_data_quality_task_report?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 标准库报告
  static async getDataStandReport(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityCheckResult/get_data_stand_report?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取规则详情页面的左侧列表
  static async getRuleDetailLeft(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdDataQualityCheckResult/GetList?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取规则问题详情表头
  static async getRuleDetailHeader(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassAttribute?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取规则问题详情接口
  static async getRuleDetailData(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityCheckResult/qs_get_rule_info_details?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取字段明细情况
  static async getField(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityCheckResult/qs_get_field_info_list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取字段明细详情
  static async getFieldDetail(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityCheckResult/qs_get_field_info_details?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 导出字段明细情况列表
  static async exportFieldInfoList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityCheckResult/qs_field_info_list_export?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 导出字段明细情况详情
  static async exportFieldDetail(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityCheckResult/qs_field_info_details_export?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取质检报告
  static async getDetails(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdDataQualityTask/get_details?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取质检报告
  static async getQualityReport(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityCheckResult/qs_get_quality_report?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 删除前的校验(校验是否有运行数据)
  static async checkHasRunData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdDataQualityTask/check-has-run-data', payload)
    )
    return Callback(err, res)
  }
  // 获取操作列表
  static async getOperatorList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/CheckTableFilter/operator-list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取操作列表
  static async getCheckTableFilterList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/CheckTableFilter?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
}
